/**************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ***************************************************************************/

export class EndpointNotAvailableException {
    constructor(configName, message) {
        this.configName = configName;
        this.message = message;
        this.name = 'EndpointNotAvailableException';
        this.title = 'Configuration not available';
    }

    get description() {
        return `The configuration ${this.configName} is not available or did not return a valid schema.`;
    }

    toString() {
        return `${this.title}: ${this.description}`;
    }
}

export class IncompatibleSchemaException {
    constructor(configName) {
        this.configName = configName;
        this.name = 'IncompatibleSchemaException';
        this.title = 'Incompatible Schema';
    }

    get description() {
        return `The schema of config ${this.configName} is incompatible with CIF.`;
    }

    toString() {
        return `${this.title}: ${this.description}`;
    }
}

export class NoConfigurationException {
    constructor() {
        this.name = 'NoConfigurationException';
        this.title = 'No Configuration Available';
        this.description = 'At least one CIF configuration is required.';
    }

    toString() {
        return `${this.title}: ${this.description}`;
    }
}
